export default "__VITE_ASSET__QHu1jHix__"